import { getLocalizaciones } from "@/api/localizaciones.api.js"

const state = {

    localizacion: [],
    curso: {}

}

const getters = {

    /**
     * Return localizacion
     * 
     */

    getLocalizacion(state) {

        return state.localizacion

    },

    /**
     * Return curso
     * 
     */

    getCursoLocalizacion(state) {

        return state.curso

    },

}

const actions = {

    /**
     * Fetch localizacion segun el subdominio desde el que accede
     * 
     */

    async fetchLocalizacion({ commit }, slug) {

        try {

            const response = await getLocalizaciones(slug)

            commit('SET_LOCALIZACION', response.data)
            commit('SET_CURSO', response.data[0].ultimoCurso)

        } catch (error) {

            console.log(error)

        }    

    }

}

const mutations = {

    /**
     * Add localizacion al estado
     * 
     */
    
     SET_LOCALIZACION(state, data) {

        state.localizacion = data

    },

    /**
     * Add idiomas al estado
     * 
     */
    
     SET_IDIOMAS(state, data) {

        state.idiomas = data

    },

    /**
     * Add curso al estado
     * 
     */
    
     SET_CURSO(state, data) {

        state.curso = data

    }

}

export default {

    namespaced: true,
    state,
    getters,
    actions,
    mutations
    
}
